import React from "react";

const ErrorMessage = (props) => {
  return (
    <p>
      {props.children ? props.children : "There has been an error."}
    </p>
  );
}

export default ErrorMessage;
